import { render } from "./TipsCard.vue?vue&type=template&id=2fc62575&scoped=true"
const script = {}

import "./TipsCard.vue?vue&type=style&index=0&id=2fc62575&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fc62575"]])

export default __exports__